import Confirm from 'app/confirm/components/confirm';
import FormDialog from 'app/form-dialog/components/form-dialog';
import AgentEvalEditRun from '../agent/components/agent-eval-edit-run/index.js';
import ToolRunEdit from '../ai/tool/components/tool-edit-run';

export const GlobalModals = () => {
  return (
    <>
      <Confirm />
      <FormDialog />
      <AgentEvalEditRun />
      <ToolRunEdit />
    </>
  );
};
